export default {
  YOU_NEED_BE_LOGGED: 'Você precisa estar logado para acessar este recurso.'
};
